export const pfttPlusSevenCriteria = '1057'